import moment from "moment";
export function Minutes__Time(minutes: number) {
  return moment(minutes * 60, "X")
    .utc()
    .format("HH:mm");
}
